import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from 'html-react-parser'

import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { discountTypeObj, subscriptionPlanType, subscriptionPlanTypeObj } from "../../../../utils/Constants";
import { TempleDetails } from "../../services/temple.services";

const ViewTemple = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Temple"),
      url: "/admin/temples/list/1",
    },
    { title: t("View"), url: "" },
  ];


  useEffect(() => {
    TempleDetails(params.id)
      .then((response) => {
        console.log(response.data);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">
                  {t("View Coupon")}
                </h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Temple Name")}</th>
                          <td className="text-capitalize">
                            {showdefault?.templeName || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Temple Location")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.templeLocation
                              ? showdefault.templeLocation
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Temple Description")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.templeDesc
                              ? showdefault.templeDesc
                              : "N/A"}
                          </td>
                        </tr> 
                        <tr>
                            <th>{t("Temple Image")}</th>
                            <td className="text-capitalize">
                                {showdefault?.templeImage ? (
                                <img
                                    src={showdefault.templeImage}
                                    alt="Temple"
                                    style={{
                                    width: "150px",
                                    height: "auto",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    }}
                                />
                                ) : (
                                "N/A"
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th>{t("list_heading_status")}</th>
                            <td>
                            {showdefault && showdefault?.status == true ? toHtml(showStatus(1)) : toHtml(showStatus(0))}
                            </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
            <div className="ml-4 back-button mx-0">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/temples/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewTemple;
